// @generated by TypeGen from LogbookModel/Day/DayWatch.swift - DO NOT EDIT

export interface IDayWatchData {
  type: IDayWatchType;
  groups: IDayWatchGroup[];
  shifts: IDayWatchShift[];
}

export interface IDayWatchGroup {
  id: string;
  name: string;
  people: number[];
}

export interface IDayWatchShift {
  id: string;
  start: number;
  duration: number;
  group?: string;
}

export enum IDayWatchType {
  manual = "manual",
}
